import LinkedInIcon from "@mui/icons-material/LinkedIn";
import {
  Avatar,
  Box,
  Grid,
  Link,
  Typography,
} from "@mui/material";
import React from "react";
import Header from "../components/Header.jsx";
import Footer from "../components/Footer";
import Emmanuel from "../img/Team/Emmanuel.jpg";
import Inheritance from "../img/Team/Inheritance.jpg";
import Dharmanshi from "../img/Team/Dharmanshi.jpg";
import Anthony from "../img/Team/Anthony2.png";
import Joanne from "../img/Team/Joanne.jpg";
import Nawfal from "../img/Team/Nawfal.jpg";
import Bhavya from "../img/Team/Bhavya.jpeg";
import Carl from "../img/Team/Carl.jpeg";
import Ann from "../img/Team/Ann-Francisca.jpeg";
import Ife from "../img/Team/Ife.jpeg";
import Nathaniel from "../img/Team/Nathaniel.jpeg";

import "./TeamPage.css";


const TeamPage = () => {
  return (
    <Box sx={{ width: "100%", bgcolor: "background.paper" }}>
      <Header />

      <Box
        sx={{
          width: "85%",
          margin: "0 auto",
          textAlign: "center",
          mt: 8,
          mb: 12,
        }}
      >
        <Typography variant="h2" sx={{ fontWeight: 500, mb: 4, fontSize: {xs: "2rem", md: "3rem" } }}>
          Meet the LyncFit team...
        </Typography>

        {/* Done Manually */}
        <div className="grid-container">

        {/* First Row */}
            <div className="row four-col">
                {/* Emman */}
                <div className="grid-item">
                <div className="circle">
                    <div className="avatar-row">
                        <Avatar
                            src={Emmanuel}
                            alt="Emmanuel Dei"
                            sx={{ 
                                width: "250px", /* Bigger size */
                                height: "250px", /* Bigger size */
                                margin: "0 auto" 
                            }}
                        />
                    </div>
                    <div className="name-row">
                        <Typography variant="h4" sx={{ fontWeight: 500, mt: 2 }}>
                            Emmanuel Dei
                        </Typography>
                    </div>
                    <div className="role-row">
                        <Typography
                        variant="body1"
                        sx={{
                            color: "#212020",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "5px",
                        }}
                        >
                            Co-Founder & CEO
                            
                            <Link
                                href="https://www.linkedin.com/in/emmanuel-dei/"
                                target="_blank"
                                rel="noopener"
                                sx={{ display: "inline-flex", alignItems: "center" }}
                            >
                                <LinkedInIcon sx={{ fontSize: "2rem", ml: 0.5 }} />
                            </Link>
                            
                        </Typography>
                    </div>
                </div>
                </div>
                
                {/* Inheritance */}
                <div className="grid-item">
                <div className="circle">
                    <div className="avatar-row">
                        <Avatar
                            src={Inheritance}
                            alt="Inheritance Odili"
                            sx={{ 
                                width: "250px",
                                height: "250px",
                                margin: "0 auto" 
                            }}
                        />
                    </div>

                    <div className="name-row">
                        <Typography variant="h4" sx={{ fontWeight: 500, mt: 2 }}>
                            Inheritance Odili
                        </Typography>
                    </div>

                    <div className="role-row">
                        <Typography
                            variant="body1"
                            sx={{
                            color: "#212020",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "5px",
                            }}
                        >
                            Co-Founder & COO
                            
                            <Link
                                href="https://www.linkedin.com/in/inheritance-odili/"
                                target="_blank"
                                rel="noopener"
                                sx={{ display: "inline-flex", alignItems: "center" }}
                            >
                                <LinkedInIcon sx={{ fontSize: "2rem", ml: 0.5 }} />
                            </Link>
                            
                        </Typography>
                    </div>
                </div>
                </div>

                {/* Dharmanshi */}
                <div className="grid-item blue">
                    <div className="circle">
                        <div className="avatar-row">
                            <Avatar
                                src={Dharmanshi}
                                alt="Dharmanshi Sangani"
                                sx={{ 
                                    width: "250px", /* Bigger size */
                                    height: "250px", /* Bigger size */
                                    margin: "0 auto" 
                                }}
                            />
                        </div>
                        <div className="name-row">
                            <Typography variant="h4" sx={{ fontWeight: 500, mt: 2 }}>
                                Dharmanshi Sangani
                            </Typography>
                        </div>
                        <div className="role-row">
                            <Typography
                                variant="body1"
                                sx={{
                                color: "#212020",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: "5px",
                                }}
                            >
                                CTO
                                
                                <Link
                                    href="https://www.linkedin.com/in/dharmanshi-sangani-172b9719b/"
                                    target="_blank"
                                    rel="noopener"
                                    sx={{ display: "inline-flex", alignItems: "center" }}
                                >
                                    <LinkedInIcon sx={{ fontSize: "2rem", ml: 0.5 }} />
                                </Link>
                                
                            </Typography>
                        </div>
                    </div>
                </div>

                                {/* Joanne */}
                <div className="grid-item">
                    <div className="circle">
                        <div className="avatar-row">
                            <Avatar
                                src={Joanne}
                                alt="Inheritance Odili"
                                sx={{ 
                                    width: "250px",
                                    height: "250px",
                                    margin: "0 auto" 
                                }}
                            />
                        </div>

                        <div className="name-row">
                            <Typography variant="h4" sx={{ fontWeight: 500, mt: 2 }}>
                                Joanne Lee
                            </Typography>
                        </div>
                        <div className="role-row">
                            <Typography
                                variant="body1"
                                sx={{
                                color: "#212020",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: "5px",
                                }}
                            >
                                Software Engineer
                                
                                <Link
                                    href="https://www.linkedin.com/in/joan-joanne-lee/"
                                    target="_blank"
                                    rel="noopener"
                                    sx={{ display: "inline-flex", alignItems: "center" }}
                                >
                                    <LinkedInIcon sx={{ fontSize: "2rem", ml: 0.5 }} />
                                </Link>
                                
                            </Typography>
                        </div>
                    </div>
                </div>
            </div>
        
        {/* Second Row */}
            <div className="row three-col">
                {/* Anthony */}
                <div className="grid-item">
                    <div className="circle">
                        <div className="avatar-row">
                            <Avatar
                                src={Anthony}
                                alt="Anthony Imafidon"
                                sx={{ 
                                    width: "250px", /* Bigger size */
                                    height: "250px", /* Bigger size */
                                    margin: "0 auto" 
                                }}
                            />
                        </div>
                        <div className="name-row">
                            <Typography variant="h4" sx={{ fontWeight: 500, mt: 2 }}>
                                Anthony Imafidon
                            </Typography>
                        </div>
                        <div className="role-row">
                            <Typography
                            variant="body1"
                            sx={{
                                color: "#212020",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: "5px",
                            }}
                            >
                                Software Engineer
                                
                                <Link
                                    href="https://www.linkedin.com/in/anthony-imafidon-127482130/"
                                    target="_blank"
                                    rel="noopener"
                                    sx={{ display: "inline-flex", alignItems: "center" }}
                                >
                                    <LinkedInIcon sx={{ fontSize: "2rem", ml: 0.5 }} />
                                </Link>
                                
                            </Typography>
                        </div>
                    </div>
                </div>

                {/* Nawfal */}
                <div className="grid-item blue">
                    <div className="circle">
                        <div className="avatar-row">
                            <Avatar
                                src={Nawfal}
                                alt="Muhammed Nawfal"
                                sx={{ 
                                    width: "250px", /* Bigger size */
                                    height: "250px", /* Bigger size */
                                    margin: "0 auto" 
                                }}
                            />
                        </div>
                        <div className="name-row">
                            <Typography variant="h4" sx={{ fontWeight: 500, mt: 2 }}>
                                Muhammed Nawfal
                            </Typography>
                        </div>
                        <div className="role-row">
                            <Typography
                                variant="body1"
                                sx={{
                                color: "#212020",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: "5px",
                                }}
                            >
                                Software Engineer
                                
                                <Link
                                    href="https://www.linkedin.com/in/muhammed-nawfal"
                                    target="_blank"
                                    rel="noopener"
                                    sx={{ display: "inline-flex", alignItems: "center" }}
                                >
                                    <LinkedInIcon sx={{ fontSize: "2rem", ml: 0.5 }} />
                                </Link>
                                
                            </Typography>
                        </div>
                    </div>
                </div>
            </div>

            {/* Third Row */}
            <div className="row four-col">
                                
            {/* Bhavya */}
                <div className="grid-item blue">
                        <div className="circle">
                            <div className="avatar-row">
                                <Avatar
                                    src={Bhavya}
                                    alt="Bhavya Gandhi"
                                    sx={{ 
                                        width: "250px", /* Bigger size */
                                        height: "250px", /* Bigger size */
                                        margin: "0 auto" 
                                    }}
                                />
                            </div>
                            <div className="name-row">
                                <Typography variant="h4" sx={{ fontWeight: 500, mt: 2 }}>
                                    Bhavya Gandhi
                                </Typography>
                            </div>
                            <div className="role-row">
                                <Typography
                                    variant="body1"
                                    sx={{
                                    color: "#212020",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    gap: "5px",
                                    }}
                                >
                                    Sales Associate
                                    
                                    <Link
                                        href="https://www.linkedin.com/in/bhavya-gandhi-363728213?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app"
                                        target="_blank"
                                        rel="noopener"
                                        sx={{ display: "inline-flex", alignItems: "center" }}
                                    >
                                        <LinkedInIcon sx={{ fontSize: "2rem", ml: 0.5 }} />
                                    </Link>
                                    
                                </Typography>
                            </div>
                        </div>
                </div>

                                    {/* Ann */}
                <div className="grid-item blue">
                        <div className="circle">
                            <div className="avatar-row">
                                <Avatar
                                    src={Ann}
                                    alt="Ann-Francisca Addai"
                                    sx={{ 
                                        width: "250px", /* Bigger size */
                                        height: "250px", /* Bigger size */
                                        margin: "0 auto" 
                                    }}
                                />
                            </div>
                            <div className="name-row">
                                <Typography variant="h4" sx={{ fontWeight: 500, mt: 2 }}>
                                    Ann-Francisca Addai
                                </Typography>
                            </div>
                            <div className="role-row">
                                <Typography
                                    variant="body1"
                                    sx={{
                                    color: "#212020",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    gap: "5px",
                                    }}
                                >
                                    Sales Associate
                                    
                                    <Link
                                        href="https://uk.linkedin.com/in/annfranciscaaddai"
                                        target="_blank"
                                        rel="noopener"
                                        sx={{ display: "inline-flex", alignItems: "center" }}
                                    >
                                        <LinkedInIcon sx={{ fontSize: "2rem", ml: 0.5 }} />
                                    </Link>
                                    
                                </Typography>
                            </div>
                        </div>
                </div>

                                    {/* Carl */}
                <div className="grid-item blue">
                        <div className="circle">
                            <div className="avatar-row">
                                <Avatar
                                    src={Carl}
                                    alt="Carl Awity"
                                    sx={{ 
                                        width: "250px", /* Bigger size */
                                        height: "250px", /* Bigger size */
                                        margin: "0 auto" 
                                    }}
                                />
                            </div>
                            <div className="name-row">
                                <Typography variant="h4" sx={{ fontWeight: 500, mt: 2 }}>
                                    Carl Awity
                                </Typography>
                            </div>
                            <div className="role-row">
                                <Typography
                                    variant="body1"
                                    sx={{
                                    color: "#212020",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    gap: "5px",
                                    }}
                                >
                                    Marketing Associate
                                    
                                    <Link
                                        href="https://www.linkedin.com/in/carl-a-985429223"
                                        target="_blank"
                                        rel="noopener"
                                        sx={{ display: "inline-flex", alignItems: "center" }}
                                    >
                                        <LinkedInIcon sx={{ fontSize: "2rem", ml: 0.5 }} />
                                    </Link>
                                    
                                </Typography>
                            </div>
                        </div>
                </div>

                            {/* Ife */}
                <div className="grid-item blue">
                        <div className="circle">
                            <div className="avatar-row">
                                <Avatar
                                    src={Ife}
                                    alt="Ifeoluwa Kuye"
                                    sx={{ 
                                        width: "250px", /* Bigger size */
                                        height: "250px", /* Bigger size */
                                        margin: "0 auto" 
                                    }}
                                />
                            </div>
                            <div className="name-row">
                                <Typography variant="h4" sx={{ fontWeight: 500, mt: 2, fontSize: "31px" }}>
                                    Ifeoluwa Kuye
                                </Typography>
                            </div>
                            <div className="role-row">
                                <Typography
                                    variant="body1"
                                    sx={{
                                    color: "#212020",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    gap: "5px",
                                    }}
                                >
                                    Marketing Associate
                                    
                                    <Link
                                        href="http://www.linkedin.com/in/ifeoluwa-k-84665b213"
                                        target="_blank"
                                        rel="noopener"
                                        sx={{ display: "inline-flex", alignItems: "center" }}
                                    >
                                        <LinkedInIcon sx={{ fontSize: "2rem", ml: 0.5 }} />
                                    </Link>
                                    
                                </Typography>
                            </div>
                        </div>
                </div>

            </div>

            {/* Fourth Row */}
            <div className="row three-col">

                                    {/* Nathaniel */}
                <div className="grid-item blue">
                        <div className="circle">
                            <div className="avatar-row">
                                <Avatar
                                    src={Nathaniel}
                                    alt="Nathaniel Walker"
                                    sx={{ 
                                        width: "250px", /* Bigger size */
                                        height: "250px", /* Bigger size */
                                        margin: "0 auto" 
                                    }}
                                />
                            </div>
                            <div className="name-row">
                                <Typography variant="h4" sx={{ fontWeight: 500, mt: 2 }}>
                                    Nathaniel Walker
                                </Typography>
                            </div>
                            <div className="role-row">
                                <Typography
                                    variant="body1"
                                    sx={{
                                    color: "#212020",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    gap: "5px",
                                    }}
                                >
                                    Photographer
                                    
                                    <Link
                                        href="https://www.linkedin.com/in/nathaniel-walker-15224a215?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app"
                                        target="_blank"
                                        rel="noopener"
                                        sx={{ display: "inline-flex", alignItems: "center" }}
                                    >
                                        <LinkedInIcon sx={{ fontSize: "2rem", ml: 0.5 }} />
                                    </Link>
                                    
                                </Typography>
                            </div>
                        </div>
                </div>

                
            </div>
        </div>

        
      </Box>
      <Footer />
    </Box>
  );
};

export default TeamPage;